(function () {
    'use strict';

    angular
        .module('atheer.public', [

        ]);
})();